/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowsend2Inputs */

const en_aiflowsend2 = /** @type {(inputs: Aiflowsend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const de_aiflowsend2 = /** @type {(inputs: Aiflowsend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Aiflowsend2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowsend2 = /** @type {((inputs?: Aiflowsend2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowsend2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowsend2(inputs)
	return de_aiflowsend2(inputs)
});
export { aiflowsend2 as "aiFlowSend" }